/* Weaving Creation — theme behaviours: header transparency, mobile nav,
   cart drawer + AJAX cart, product variant selection. Vanilla JS, no deps. */
(function () {
  "use strict";

  function formatMoney(cents) {
    var fmt = (window.WC && window.WC.money) || "${{amount}}";
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/g, amount)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
  }

  /* ---------- Header transparency over hero ---------- */
  var header = document.querySelector(".site-header");
  if (header && header.dataset.transparent === "true") {
    var onScroll = function () {
      if (window.scrollY > 24) header.classList.remove("is-transparent");
      else header.classList.add("is-transparent");
    };
    header.classList.add("is-transparent");
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- a11y dialog helpers (Escape, focus return, focus trap) ---------- */
  function wcFocusables(el) {
    if (!el) return [];
    return [].slice.call(el.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (n) { return n.offsetWidth || n.offsetHeight || n === document.activeElement; });
  }
  function wcTrapTab(e, panel) {
    var f = wcFocusables(panel);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Mobile nav ---------- */
  var mobileNav = document.getElementById("MobileNav");
  var mobileNavPanel = mobileNav && mobileNav.querySelector(".mobile-nav__panel");
  var menuOpeners = document.querySelectorAll("[data-menu-open]");
  var navReturnFocus = null;
  function navKey(e) { if (e.key === "Escape") closeMobileNav(); else if (e.key === "Tab") wcTrapTab(e, mobileNavPanel); }
  function openMobileNav() {
    if (!mobileNav) return;
    navReturnFocus = document.activeElement;
    mobileNav.classList.add("is-open");
    mobileNav.removeAttribute("aria-hidden");
    menuOpeners.forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
    document.documentElement.style.overflow = "hidden";
    var f = wcFocusables(mobileNavPanel); (f[0] || mobileNavPanel).focus();
    document.addEventListener("keydown", navKey);
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove("is-open");
    mobileNav.setAttribute("aria-hidden", "true");
    menuOpeners.forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
    document.documentElement.style.overflow = "";
    document.removeEventListener("keydown", navKey);
    if (navReturnFocus && navReturnFocus.focus) navReturnFocus.focus();
  }
  menuOpeners.forEach(function (b) { b.addEventListener("click", openMobileNav); });
  document.querySelectorAll("[data-menu-close]").forEach(function (b) {
    b.addEventListener("click", closeMobileNav);
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById("CartDrawer");
  var drawerPanel = drawer && drawer.querySelector(".cart-drawer__panel");
  var cartOpeners = document.querySelectorAll("[data-cart-open]");
  var cartReturnFocus = null;
  function drawerKey(e) { if (e.key === "Escape") closeDrawer(); else if (e.key === "Tab") wcTrapTab(e, drawerPanel); }
  function openDrawer() {
    if (!drawer) return;
    cartReturnFocus = document.activeElement;
    drawer.classList.add("is-open");
    drawer.removeAttribute("aria-hidden");
    cartOpeners.forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
    document.documentElement.style.overflow = "hidden";
    var closeBtn = drawer.querySelector(".cart-drawer__head [data-cart-close]") || wcFocusables(drawerPanel)[0];
    if (closeBtn) closeBtn.focus();
    document.addEventListener("keydown", drawerKey);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    cartOpeners.forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
    document.documentElement.style.overflow = "";
    document.removeEventListener("keydown", drawerKey);
    if (cartReturnFocus && cartReturnFocus.focus) cartReturnFocus.focus();
  }
  cartOpeners.forEach(function (b) {
    b.addEventListener("click", function (e) { e.preventDefault(); openDrawer(); });
  });
  document.querySelectorAll("[data-cart-close]").forEach(function (b) {
    b.addEventListener("click", closeDrawer);
  });

  function renderCart(cart) {
    var countEls = document.querySelectorAll("[data-cart-count]");
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? "flex" : "none";
    });

    var itemsEl = document.querySelector("[data-cart-items]");
    var footEl = document.querySelector("[data-cart-foot]");
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
      if (footEl) footEl.style.display = "none";
      return;
    }
    if (footEl) footEl.style.display = "block";

    itemsEl.innerHTML = cart.items.map(function (item) {
      // Paid add-ons (embroidery, Magen David, tekhelet…) have no product image —
      // render them as a compact inline customization instead of a blank product.
      if (item.product_type === "Add-on") {
        var avt = item.variant_title && item.variant_title !== "Default Title" ? " — " + item.variant_title : "";
        var forWhom = "";
        if (item.properties) { var f = item.properties["For"] || item.properties["Add-on for"]; if (f) forWhom = '<p class="cart-line__variant">for ' + f + "</p>"; }
        return '<div class="cart-line cart-line--addon" data-key="' + item.key + '">' +
            '<span class="cart-line__addon-ico"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M12 3l1.8 4.7L18.5 9.5 13.8 11.3 12 16l-1.8-4.7L5.5 9.5l4.7-1.8z"/></svg></span>' +
            "<div>" +
              '<p class="cart-line__title">' + item.product_title + avt + "</p>" +
              forWhom +
              '<p class="cart-line__price">+' + formatMoney(item.final_line_price) + "</p>" +
            "</div>" +
            '<button class="cart-line__remove" data-remove>Remove</button>' +
          "</div>";
      }
      var img = item.image ? '<img src="' + item.image.replace(/(\.[^.]+)$/, "_200x$1") + '" alt="' + (item.product_title || "") + '">' : "";
      var variant = item.variant_title && item.variant_title !== "Default Title" ? '<p class="cart-line__variant">' + item.variant_title + "</p>" : "";
      return '' +
        '<div class="cart-line" data-key="' + item.key + '">' +
          '<a class="cart-line__media" href="' + item.url + '">' + img + "</a>" +
          "<div>" +
            '<p class="cart-line__title">' + item.product_title + "</p>" +
            variant +
            '<p class="cart-line__price">' + formatMoney(item.final_line_price) + "</p>" +
            '<div class="cart-line__qty">' +
              '<button data-qty-dec aria-label="Decrease">&minus;</button>' +
              "<span>" + item.quantity + "</span>" +
              '<button data-qty-inc aria-label="Increase">+</button>' +
            "</div>" +
          "</div>" +
          '<button class="cart-line__remove" data-remove>Remove</button>' +
        "</div>";
    }).join("");

    var totalEl = document.querySelector("[data-cart-total]");
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch(window.WC.routes.cart + ".js", { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, quantity) {
    return fetch(window.WC.routes.cartChange + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); });
  }

  if (drawer) {
    drawer.addEventListener("click", function (e) {
      var line = e.target.closest(".cart-line");
      if (!line) return;
      var key = line.dataset.key;
      var qtySpan = line.querySelector(".cart-line__qty span");
      var qty = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
      if (e.target.closest("[data-qty-inc]")) changeLine(key, qty + 1);
      else if (e.target.closest("[data-qty-dec]")) changeLine(key, Math.max(0, qty - 1));
      else if (e.target.closest("[data-remove]")) changeLine(key, 0);
    });
  }

  function addToCart(variantId, quantity, properties) {
    var body = { id: variantId, quantity: quantity || 1 };
    if (properties) body.properties = properties;
    return fetch(window.WC.routes.cartAdd + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (r.status === 422) return r.json().then(function (e) { throw new Error(e.description || "Unable to add"); });
      return r.json();
    }).then(function () { return fetchCart(); }).then(function () { openDrawer(); });
  }

  /* add several lines at once (used by the tallit builder) */
  function addItems(items) {
    return fetch(window.WC.routes.cartAdd + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (r.status === 422) return r.json().then(function (e) { throw new Error(e.description || "Unable to add"); });
      return r.json();
    }).then(function () { return fetchCart(); }).then(function () { openDrawer(); });
  }
  window.WCBuilderAdd = addItems;

  /* quick add buttons (product cards) */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-quick-add]");
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute("data-quick-add");
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = "Adding…";
    addToCart(id, 1).catch(function (err) { alert(err.message); })
      .finally(function () { btn.disabled = false; btn.textContent = label; });
  });

  /* ---------- Product page variant selection ---------- */
  var form = document.querySelector("[data-product-form]");
  if (form) {
    var variants = JSON.parse(form.getAttribute("data-variants") || "[]");
    var selected = {};
    form.querySelectorAll(".option__btn").forEach(function (b) {
      if (b.classList.contains("is-selected")) selected[b.dataset.optName] = b.dataset.optValue;
    });

    function currentVariant() {
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return selected["option" + (i + 1)] === val; });
      });
    }
    function updateState() {
      var v = currentVariant();
      var idInput = form.querySelector("[data-variant-id]");
      var priceEl = document.querySelector("[data-product-price]");
      var addBtn = form.querySelector("[data-add-btn]");
      var stickyPrice = document.querySelector("[data-sticky-price]");
      var mobileLabel = document.querySelector("[data-mobile-label]");
      var mobileBtn = document.querySelector("[data-mobile-add]");
      if (v) {
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? "Add to Cart" : "Sold Out";
        }
        if (mobileBtn) mobileBtn.disabled = !v.available;
        if (mobileLabel) mobileLabel.textContent = v.available ? "Add to Cart" : "Sold Out";
      } else {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = "Unavailable"; }
        if (mobileBtn) mobileBtn.disabled = true;
        if (mobileLabel) mobileLabel.textContent = "Unavailable";
      }
    }

    document.querySelectorAll("[data-mobile-add]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (form.requestSubmit) form.requestSubmit();
        else { var ab = form.querySelector("[data-add-btn]"); if (ab) ab.click(); }
      });
    });

    // Only the variant (size) buttons carry data-opt-name; the builder's own
    // data-group buttons (tzitzit/knot/tekhelet/…) are handled by wc-builder.js /
    // wc-options.js. Binding this to ALL .option__btn added is-selected to those
    // too without clearing siblings — the "marks in addition" bug (client 2026-08-02).
    form.querySelectorAll(".option__btn[data-opt-name]").forEach(function (b) {
      b.addEventListener("click", function () {
        var name = b.dataset.optName;
        form.querySelectorAll('.option__btn[data-opt-name="' + name + '"]').forEach(function (x) { x.classList.remove("is-selected"); });
        b.classList.add("is-selected");
        selected[name] = b.dataset.optValue;
        updateState();
      });
    });

    // gallery thumbnails
    var mainImg = document.querySelector("[data-main-img]");
    form && document.querySelectorAll("[data-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        if (mainImg) mainImg.src = t.getAttribute("data-full");
        document.querySelectorAll("[data-thumb]").forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
      });
    });

    // qty stepper
    var qtyInput = form.querySelector("[data-qty-input]");
    form.querySelectorAll("[data-qty-step]").forEach(function (b) {
      b.addEventListener("click", function () {
        var step = parseInt(b.getAttribute("data-qty-step"), 10);
        var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
        qtyInput.value = val;
      });
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var v = currentVariant();
      if (!v || !v.available) return;
      var qty = parseInt(qtyInput ? qtyInput.value : "1", 10) || 1;
      var props = {};
      form.querySelectorAll("[data-property]").forEach(function (el) {
        if (el.type === "checkbox") { if (el.checked) props[el.getAttribute("data-property")] = el.value; }
        else if (el.value) props[el.getAttribute("data-property")] = el.value;
      });
      var addBtn = form.querySelector("[data-add-btn]");
      if (addBtn) addBtn.textContent = "Adding…";
      addToCart(v.id, qty, Object.keys(props).length ? props : null)
        .catch(function (err) { alert(err.message); })
        .finally(function () { if (addBtn) addBtn.textContent = "Add to Cart"; });
    });

    updateState();
  }

  /* auto-rotating testimonials. Exposed so the live-Google-reviews script can
     re-init a container after it swaps the slides/dots in. */
  function initTesti(wrap) {
    var slides = wrap.querySelectorAll("[data-testi-slide]");
    var dots = wrap.parentElement.querySelectorAll("[data-testi-dot]");
    if (slides.length < 2) return;
    var i = 0, timer;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle("is-active", k === i); });
      dots.forEach(function (d, k) { d.classList.toggle("is-active", k === i); });
    }
    function start() { timer = setInterval(function () { show(i + 1); }, 6000); }
    dots.forEach(function (d) {
      d.addEventListener("click", function () { clearInterval(timer); show(parseInt(d.getAttribute("data-testi-dot"), 10)); start(); });
    });
    start();
  }
  window.wcInitTesti = initTesti;
  document.querySelectorAll("[data-testi]").forEach(function (wrap) {
    /* Live-Google containers are owned by wc-google-reviews.js — it calls
       wcInitTesti itself once the fetch resolves (or falls back). */
    if (wrap.hasAttribute("data-testi-managed")) return;
    initTesti(wrap);
  });

  /* self-moving carousels — transform marquee (always moves, regardless of overflow) */
  document.querySelectorAll("[data-autoscroll]").forEach(function (el) {
    var items = Array.prototype.slice.call(el.children);
    if (!items.length) return;
    var track = document.createElement("div");
    track.style.display = "flex";
    track.style.gap = getComputedStyle(el).columnGap || getComputedStyle(el).gap || "1.25rem";
    track.style.willChange = "transform";
    items.forEach(function (it) { track.appendChild(it); });
    items.forEach(function (it) { track.appendChild(it.cloneNode(true)); });
    el.appendChild(track);
    el.style.overflow = "hidden";
    el.style.display = "block";
    var firstClone = track.children[items.length];
    var pos = 0, paused = false;
    el.addEventListener("mouseenter", function () { paused = true; });
    el.addEventListener("mouseleave", function () { paused = false; });
    el.addEventListener("touchstart", function () { paused = true; }, { passive: true });
    el.addEventListener("touchend", function () { paused = false; });
    function tick() {
      if (!paused && firstClone && firstClone.offsetLeft > 0) {
        pos += 0.5;
        if (pos >= firstClone.offsetLeft) pos -= firstClone.offsetLeft;
        track.style.transform = "translateX(" + (-pos) + "px)";
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  });

  /* SIGNATURE — scroll-driven weaving REMOVED per Yosef 2026-07-28 (clean white background). */
  (function () {
    return;
    var startEl = document.querySelector('.value-strip')
      || document.querySelector('[id*="__value_strip"]')
      || document.querySelector('[id*="__collections"]')
      || document.querySelector('.coll-grid');
    if (!startEl) return;
    var root = document.documentElement;
    function onWeave() {
      var startTop = startEl.getBoundingClientRect().top + window.scrollY;
      var end = root.scrollHeight;
      var cur = window.scrollY + window.innerHeight;
      var p = (cur - startTop) / Math.max(1, end - startTop);
      p = Math.max(0, Math.min(1, p));
      root.style.setProperty('--weave', p.toFixed(3));
      root.style.setProperty('--weave-on', p > 0.01 ? '1' : '0');
    }
    window.addEventListener('scroll', onWeave, { passive: true });
    window.addEventListener('resize', onWeave);
    onWeave();
  })();

  fetchCart();
})();
